"use strict";

angular.module("exploitation")

	.controller("ExploitLinesCtrl", ["$scope", "Utils", "$uibModal", "$route", "toastr", "ExploitationService", "CartoService", "SecurityService", "$sanitize",
		function ($scope, Utils, $uibModal, $route, toastr, ExploitationService, CartoService, SecurityService, $sanitize) {


		/**************************************************************************************************************
		 * Configuration / init
		 **************************************************************************************************************/

		let	lineModal, lineBackup;

		let selectedLineWeightRatio = 2;

		let tadWarningModal;
		let wheelchairWarningModal;
		let bikeWarningModal;
		let schoolBusWarningModal;

		$scope.loading = false;
		$scope.data.selectedCategory = null;
		$scope.data.linesToDisplay = {};
		$scope.data.groupOflines = {};
		// so it can be accessed in the view
		$scope.exploitationService = ExploitationService;
		$scope.utilsService = Utils;

		$scope.isAllSelected = false;
		$scope.isAllSelectedFromModal = false;

		$scope.sortColumn = "position";
		$scope.reverseSort = false;

		let OkinaLeafletService = $scope.LeafletService;

		// Ajoute l'evenement de modification de la largeur des lignes tracés en fonction du zoom
		// on pourrait mettre moveend aussi.... bref bizarre
		OkinaLeafletService.addEventOnMap("zoomend", 0, function (event) {
			// parce que... moveend est de la même famille de zoomend ?
			if(event.type !== "zoomend") return;
			let zoom = event.sourceTarget.getZoom();
			// Valeur arbitraire pour garder une cohérence vis à vis du niveau de zoom
			let stokeWidth = zoom/4;
			let lines = $scope.data.lines;
			if (zoom >= 10 && lines != null) {
				for (let i = 0; i < lines.length; i++) {
					let line = lines[i];
					let layer = getLayerByLineId(line.id);
					if (undefined === layer || null == layer) {
						return;
					}
					if ($scope.data.selectedLine !== undefined && line.id === $scope.data.selectedLine.id) {
						layer.setStyle({weight: stokeWidth * selectedLineWeightRatio}); // On grossit de 200% la ligne sélectionnée
					} else {
						layer.setStyle({weight: stokeWidth});
					}
				}
			}
		});
		/**************************************************************************************************************
		 * Scope functions
		 **************************************************************************************************************/




		$scope.saveLinesOrder = function() {
			for (let i = 0; i < $scope.data.lines.length; i++) {
				let linePosition = i+1;

				if (linePosition !== $scope.data.lines[i].position){
					$scope.data.lines[i].position = linePosition;
					ExploitationService.editLine($scope.data.lines[i], false, true)
						.then(() => {})
						.catch((error) => {
						toastr.error(error, "");
						$scope.data.loading = false;
					});
				}
			}
		};



		/**
		 * Sélectionner ou déselectionner toutes les lignes
		 */
		$scope.toggleAll = function () {
			$scope.isAllSelected = !$scope.isAllSelected;
			for (let indexLine in $scope.data.lines) {
				let line = $scope.data.lines[indexLine];
				$scope.data.linesToDisplay[line.id] = $scope.isAllSelected;
				$scope.toggleLineOnMap(line);
			}
		};

		$scope.isColorTextInvalid = false;
		$scope.isColorInvalid = false;
		$scope.hexaErrorMessage = "Le code couleur hexadécimal est invalide: 7 caractères sont requis. Exemple: #EE82EE";

		$scope.validateHexColor = function(color) {
			if (!color || color === "") {
				return { isValid: true, cleanColor: "" };
			}

			const hexRegex = /^#?([0-9A-Fa-f]{6})$/;
			if (!hexRegex.test(color)) {
				return { isValid: false, cleanColor: null };
			}

			let cleanColor = color.substring(1);
			if (cleanColor.length < 6) {
				return { isValid: false, cleanColor: cleanColor };
			}

			return { isValid: true, cleanColor: cleanColor };
		};

		$scope.computeColorText = function(color) {
			const result = $scope.validateHexColor(color);

			$scope.isColorTextInvalid = !result.isValid;

			if (result.isValid) {
				$scope.data.selectedLine.couleurTexte = result.cleanColor;
				$scope.data.selectedLine.htmlColorText = result.cleanColor ? "#" + result.cleanColor : "";
			}
		};

		$scope.computeColorLine = function(color) {
			const result = $scope.validateHexColor(color);

			$scope.isColorInvalid = !result.isValid;

			if (result.isValid) {
				$scope.data.selectedLine.couleur = result.cleanColor;
				$scope.data.selectedLine.htmlColor = result.cleanColor ? "#" + result.cleanColor : "";
			}
		};

		$scope.formatColorLine = function(){
			const color = $scope.data.selectedLine.htmlColor;
			if(!color || color == "#") {
				$scope.data.selectedLine.couleur = "FFFFFF";
				$scope.data.selectedLine.htmlColor = "#FFFFFF";
			}
		};

		$scope.formatColorText = function() {
			const color = $scope.data.selectedLine.htmlColorText;
			if (!color || color == "#") {
				$scope.data.selectedLine.couleurTexte = "000000";
				$scope.data.selectedLine.htmlColorText = "#000000";
			}
		};

		/**
		 * Selectionner ou deselectionner toutes les lignes depuis la modal de changement de categorie
		 */
		$scope.toggleAllfromModal = function () {
			$scope.isAllSelectedFromModal = !$scope.isAllSelectedFromModal;
			for (let indexLine in $scope.data.lines) {
				let line = $scope.data.lines[indexLine];
				$scope.data.groupOflines[line.id] = $scope.isAllSelectedFromModal;
			}
		};

		$scope.IsThereOneLineAtLeastBoxed = () => { return Object.values($scope.data.groupOflines).some(l => l === true) };

		/**
		 * Watch selected network to update lines when needed.
		 */
		$scope.$watch(function () {
			return (ExploitationService.getCurrentNetwork());
		}, refreshNetwork);


		/**
		 * Rafraichit l'affichage pour tracer le réseau entier
		 * @param network
		 */
		function refreshNetwork(network) {
			if (network) {
				$scope.loading = true;
				OkinaLeafletService.reset();
				// fetch data for map
				const ref = window.sessionStorage.getItem("referential");
				ExploitationService.getNetworkTrace(network.id, ref)
					.then((loaderPromise) => {
						loaderPromise.promise.then((lines) => {
							let zoomTo;
							// Pour gérer le cas de la request cancelled
							if (lines === undefined || lines == null) {
								$scope.loading = false;
								return;
							}

							for (let i = 0; i < lines.length; i++) {
								if (lines[i].itineraires) {
									if (lines[i].itineraires.length > 0) {
										lines[i].itineraires[0].geoJson = JSON.parse(lines[i].itineraires[0].geoJson);
									}
									addGeoJsonLine(lines[i]);
									if(!zoomTo ){
										if(lines[i].itineraires[0]) {
											if (lines[i].itineraires[0].geoJson.coordinates[0].length > 1) {
												zoomTo = lines[i].itineraires[0].geoJson.coordinates[0][0];
											} else {
												zoomTo = lines[i].itineraires[0].geoJson.coordinates[0];
											}
										} else {
											toastr.warning("La ligne " + lines[i].name + " n'a pas d'itinéraire");
										}
									}
								}
							}
							if (zoomTo != null && zoomTo.length !== 0) {
								OkinaLeafletService.setCenter({
									"lat": zoomTo[1],
									"lng": zoomTo[0],
									"zoom": 10
								});
							}
							$scope.loading = false;
							lines = $scope.updateLinesContent(lines);
							$scope.data.lines = lines;
						}).catch(function (error) {
							toastr.warning("Il n'y a pas de tracés dans le fichier importé", "Tracé indisponible");
						});
				});
			} else {
				$scope.data.lines = [];
				$scope.data.linesToDisplay = {};
				$scope.data.networkLines = {};
			}
		}

		/**
		 * MAJ des lignes de Dexie en fonction de ce qu'il y a en base
		 * @param lines
		 * @returns {*}
		 */

		$scope.deleteDexieLine = function(line){
			if(!line) return;
			const ref = window.sessionStorage.getItem("referential");
			ExploitationService.deleteDexieLine(ref, line);
		}

		$scope.updateLinesContent = function(lines){
			lines.forEach(function(line){
				let doDexieUpdate = false;
				if($scope.data.lines === undefined || !$scope.data.lines || !$scope.data.lines.length) return;
				let scopeLine = $scope.data.lines.find(function(l){ return l.id == line.id});
				if(scopeLine === undefined) return;
				if (scopeLine.tad != line.tad){
					line.tad = scopeLine.tad;
					doDexieUpdate = true;
				}
				if (scopeLine.bikeAccess != line.bikeAccess){
					line.bikeAccess = scopeLine.bikeAccess;
					doDexieUpdate = true;
				}
				if (scopeLine.wheelchairAccess != line.wheelchairAccess){
					line.wheelchairAccess = scopeLine.wheelchairAccess;
					doDexieUpdate = true;
				}
				if (scopeLine.category != line.category){
					line.category = scopeLine.category;
					doDexieUpdate = true;
				}
				if (scopeLine.couleur != line.couleur){
					line.couleur = scopeLine.couleur;
					doDexieUpdate = true;
				}
				if (scopeLine.couleurTexte != line.couleurTexte){
					line.couleurTexte = scopeLine.couleurTexte;
					doDexieUpdate = true;
				}
				if (scopeLine.position != line.position){
					line.position = scopeLine.position;
					doDexieUpdate = true;
				}
				if(scopeLine.transportModeName != line.transportModeName){
					line.transportModeName = scopeLine.transportModeName;
					doDexieUpdate = true;
				}
				if(scopeLine.transportMode != line.transportModeName){
					line.transportModeName = scopeLine.transportModeName;
					doDexieUpdate = true;
				}
				if(scopeLine.transportSubModeName != line.transportSubModeName){
					line.transportSubModeName = scopeLine.transportSubModeName;
					doDexieUpdate = true;
				}
				if(doDexieUpdate) {
					const ref = window.sessionStorage.getItem("referential");
					ExploitationService.updateDexie(ref, line);
				}
			});
			return lines;
		}

		/**
		 * Rafraichit l'affichage des lignes
		 */
		function refreshLines() {
			ExploitationService.getLines(ExploitationService.getCurrentNetwork().id).then((response) => {
				$scope.data.lines = response.data;
			});
		}

		/**
		 * Line selected. Notify service for cross controller communication.
		 * @param line
		 */
		$scope.lineSelected = function (line) {
			if ($scope.data.selectedLine !== undefined && $scope.data.selectedLine.id === line.id) {
				return;
			}

			line.network = ExploitationService.getCurrentNetwork().id;
			ExploitationService.setCurrentLine(line);
			// On reset la couleur de la précédente ligne
			let previouslySelectedLine = $scope.data.selectedLine;
			$scope.data.selectedLine = line;
			if (previouslySelectedLine != null && previouslySelectedLine.network === line.network) {
				let previouslySelectedLineLayer = getLayerByLineId(previouslySelectedLine.id);
				if (previouslySelectedLineLayer != null) {
					previouslySelectedLineLayer.setStyle({color: "#" + previouslySelectedLine.couleur});
					previouslySelectedLineLayer.setZIndex(0);
				}
			}

			OkinaLeafletService.deleteAllMarkers();

			// On change la couleur et on zoom sur la ligne sélectionnée
			let lineSelectedLayer = getLayerByLineId(line.id);

			let couldZoom = false;
			if (lineSelectedLayer !== undefined && lineSelectedLayer != null) {
				lineSelectedLayer.bringToFront();
				couldZoom = OkinaLeafletService.zoomOnLayer(lineSelectedLayer);
			}

			// Affiche la ligne lorsqu'on la selectionne
			$scope.data.linesToDisplay[line.id] = true;
			$scope.toggleLineOnMap(line);

			if (!couldZoom) {
				toastr.warning("La topologie n'est pas chargée ou n'est pas initialisée. Dans ce dernier cas, veuillez patienter ou la recharger", "Topologie en cours de chargement");
				return;
			}

			ExploitationService.getLineTopology(line.id)
				.then((response) => {
					const data = response.data;
					if (data.itineraires.length > 0) {
						let jPattern = data.itineraires[0];
						let stopPoints = [];
						for (let j = 0; j < jPattern.sequence_arrets.length; j++) {
							let arret = jPattern.sequence_arrets[j];
							if (j === 0) {
								arret.isStartPoint = true;
							} else if (j === jPattern.sequence_arrets.length - 1) {
								arret.isEndPoint = true;
							}

							if (arret.latitude != null && arret.longitude != null) {
								stopPoints[arret.id] = arret;
							}
						}

						for (let stopPointId in stopPoints) {
							let stopPoint = stopPoints[stopPointId];
							let color = "blue";
							if (stopPoint.isStartPoint === true) {
								color = "green";
							} else if (stopPoint.isEndPoint === true) {
								color = "red";
							}

							let leafletStopPoint = {
								lat: stopPoint.latitude,
								lng: stopPoint.longitude,
								id: stopPointId,
								lineId: line.id,
								icon: {
									type: "awesomeMarker",
									icon: "circle",
									prefix: "fa",
									markerColor: color
								},
								message: popupHTMLTemplateForPoint(stopPoint)
							};

							OkinaLeafletService.createMarker(leafletStopPoint);
						}
					}
				})
				.catch(function (error) {
					toastr.error(Utils.makeErrorMessage(error, "Echec lors de la récupération des points d'arrets."), "Erreur");
				});
		};

		/**
		 * Used to check if action  buttons must be displayed onto a table line.
		 * @param line
		 * @returns {boolean}
		 */
		$scope.isLineSelected = function (line) {
			if (ExploitationService.getCurrentLine()) {
				return line.id === ExploitationService.getCurrentLine().id;
			} else {
				return false;
			}
		};

		/**
		 * Open the group of lines edition modal window.
		 *
		 */
		$scope.openEditGroupOfLinesModal = () => {
			lineModal = Utils.openModal($uibModal, "editCategorieForAllLines.html", $scope);
		}

		/**
		 * Open the line edition modal window.
		 * @param isNewLine
		 */
		$scope.openEditLineModal = function (isNewLine) {
			lineBackup = Utils.clone($scope.data.selectedLine);
			$scope.data.isNewLine = isNewLine;
			if (isNewLine) {
				$scope.data.selectedLine = {};
			}
			if ($scope.data.selectedLine != null) {
				if ($scope.data.selectedLine.couleur) {
					$scope.data.selectedLine.htmlColor = "#" + $scope.data.selectedLine.couleur;
				}
				if($scope.data.selectedLine.couleurTexte) {
					$scope.data.selectedLine.htmlColorText = "#" + $scope.data.selectedLine.couleurTexte;
				}
				$scope.data.selectedLine.network = ExploitationService.getCurrentNetwork().id;
				lineModal = Utils.openModal($uibModal, "editLineModal.html", $scope);
			}
		};

		/**
		 * Annuler l'édition de la ligne et RAZ des valeurs.
		 */
		$scope.cancelEditLine = function () {
			lineModal.close();
			if (lineBackup) {
				for (let lineIndex in $scope.data.lines) {
					let line = $scope.data.lines[lineIndex];
					if (line.id === lineBackup.id) {
						$scope.data.lines[lineIndex] = lineBackup;
						$scope.data.selectedLine = lineBackup;
						break;
					}
				}
			}
		};

		/**
		 * Edit a line.
		 * On successful return,
		 * - re-fetch lines
		 * - close the modal,
		 */
		$scope.editLine = function () {
			$scope.data.loading = true;

			ExploitationService.editLine($scope.data.selectedLine, $scope.data.isNewLine).then((response) => {
				const line = response;

				// refetch networks if one was selected
				let currentNetwork = ExploitationService.getCurrentNetwork();
				if (currentNetwork) {
					lineModal.close();
					let previouslySelectedLine = $scope.data.selectedLine;
					$scope.data.selectedLine = undefined;

					let toastrMessage = "";

					let isCouleurTexteDifferent = lineBackup !== undefined && lineBackup.couleurTexte != line.textColor;
					let isCouleurDifferent = line.couleur === undefined || (lineBackup !== undefined && lineBackup.couleur != line.couleur);

					if (lineBackup !== undefined && lineBackup.network !== line.network) {
						// Si le réseau de la ligne a changé on doit recharger les 2 réseaux
						$scope.resetTopographieNetwork(previouslySelectedLine.network);
						$scope.resetTopographieNetwork(line.network);
						toastrMessage = "La ligne a été déplacée d'un réseau à l'autre, rechargement de la topographie des deux réseaux.";
					}
					else if(isCouleurTexteDifferent || isCouleurDifferent){
						$scope.resetTopographieNetwork(line.network);
					} else {
						const referential = window.sessionStorage.getItem("referential");
						ExploitationService.resetLocalDbNetwork(line.network, referential);
					}
					//refreshNetwork(currentNetwork);
					toastr.success(toastrMessage, $scope.data.isNewLine ? "Ligne créée avec succès" : "Ligne modifiée avec succès");
				}
				$scope.data.loading = false;

			}).catch(function (error) {
				let prefixErrorMessage = $scope.data.isNewLine ? "Un problème avec la création de la ligne" : "Un problème avec la modification de la ligne";
				toastr.error(prefixErrorMessage + ": " + error, "");
				console.error(prefixErrorMessage, error);
				$scope.data.loading = false;
			});
		};

		/**
		 * edit categorie for all boxed lines
		 */
		$scope.editCategorieMultipleLines = () => {

			$scope.data.loading = true;

			const isThereOne = $scope.IsThereOneLineAtLeastBoxed();

			if (!isThereOne) return;
			const lines = $scope.data.lines.filter(line => {
				return $scope.data.groupOflines[line.id];
				//Get only boxed lines
			}).map(line => {
				line.category = $scope.data.selectedCategory;
				return line;
			});

			ExploitationService.setCategoryGroupOfLines(lines).then(() => {
				const currentNetwork = ExploitationService.getCurrentNetwork();

				if (currentNetwork) {
					refreshNetwork(currentNetwork);
				}

				lineModal.close();
				toastr.success("Traitement effectué avec succès");
				$scope.data.loading = false;
			}).catch(function (error) {
				let prefixErrorMessage = "Un problème avec la modification de la ligne";
				toastr.error(prefixErrorMessage + ": " + error, "");
				console.error(prefixErrorMessage, error);
				$scope.data.loading = false;
			});
		};

		/**
		 * Open line deletion modal confirmation.
		 */
		$scope.openDeleteLineModal = function () {
            lineModal = Utils.openModal($uibModal, "deleteLineModal.html", $scope);
        };

		/**
		 * Delete a line.
		 * On successful return,
		 * - re-fetch lines
		 * - close the modal,
		 */
		$scope.deleteLine = function () {
			ExploitationService.deleteLine($scope.data.selectedLine.id).then(() => {
				$scope.deleteDexieLine($scope.data.selectedLine);
				refreshNetwork(ExploitationService.getCurrentNetwork());
				refreshLines();
				lineModal.close();
				toastr.success("Ligne supprimée avec succès", "");
			}).catch(function (error) {
				$scope.deleteLineMessage = "Problème lors de la suppression de la ligne. ";
				console.error("Problème lors de la suppression de la ligne", error);
			});
		};

		function getLayerByLineId(lineId) {
			return OkinaLeafletService.getGeoJSONShapeList().find(function (layer) {
				return layer.options.properties.lineId === lineId;
			});
		}

		function getStopPointsByLineId(lineId) {
			return OkinaLeafletService.markersFeatureGroup.getLayers().filter(function (layer) {
				return layer.options.lineId === lineId;
			}) || []; // Si on a aucune valeur on retourne un tableau vide
		}

		function addGeoJsonLine(line) {
			CartoService.displayTopologyLine(line, function (event) {
				let currentLineId = event.layer.options.properties.lineId;
				let currentLine = $scope.data.lines.find(function (line) {
					return line.id === currentLineId;
				});

				$scope.lineSelected(currentLine);
			});
		}

		/**
		 * Show / hide features on map.
		 * @param $event
		 * @param line
		 */
		$scope.toggleLineOnMap = function (line, $event) {
		    if ($event) {
				$event.stopPropagation();
			}

			let toggle = $scope.data.linesToDisplay[line.id];

			let lineLayer = getLayerByLineId(line.id);
			if  (lineLayer) {
				lineLayer.setStyle({opacity: toggle ? 1 : 0});
			}

			getStopPointsByLineId(line.id).forEach(function (stopPoint) {
				stopPoint.setOpacity(toggle ? 1 : 0);
			});
		};

		/**
		 * Construit la popup de l'affichage des liaison d'un point d'arret.
		 * @param point
		 * @returns {string}
		 */
		function popupHTMLTemplateForPoint(point) {
			let liaisons = "";
			let liste = point.liaisons;
			if (liste) {
				liaisons += "<br>Liaisons : <dt>";
				for (let i = 0; i < liste.length; i++) {
					let liaison = liste[i];
					liaisons = liaisons.concat("<dd>Reseau " + " : " + $sanitize(liaison.name) + "</dd>");
					for (let j = 0; j < liaison.lignes.length; j++) {
						let ligne = liaison.lignes[j];
						liaisons = liaisons.concat("<ul><li>Ligne " + $sanitize(ligne.number) + " : " + $sanitize(ligne.name) + "</li></ul>");
					}
				}
				liaisons.concat("</dt>");
			} else {
				liaisons += "<br>- Aucune liaison de ligne -";
			}
			
			return "<div class='olPopup'>" +
				"<br>Point d'arrêt: " + $sanitize(point.name) +
				"<br>Nom commercial : " + $sanitize(point.commercial_name) +
				// "<br>Sens : " + feature.attributes.point.way +
				liaisons +
				"</div>";
		}

		/**
		 * Renvoie le nom de la catégorie à partir de son numéro
		 * @param category numéro de catégorie
		 * @returns {string}
		 */
		$scope.getCategoryName = function (category) {
			switch(category) {
				case 0:
					return "";
				case 1:
					return "Défaut";
				case 2:
					return "IDFM";
			}
		};

		$scope.getCssPropertyForLine = function (line) {
			const lineTextColor = $scope.getLineTextColor(line);
			const lineBackgroundColor = $scope.getLineBackgroundColor(line);
			return {
				"text-align": 'center',
				"color": lineTextColor,
				"background-color": lineBackgroundColor,
			}
		}

		/**
		 * Retourne la couleur du texte de la ligne
		 * @param line
		 * @returns {string}
		 */
		$scope.getLineTextColor = function (line) {
			if (!line.couleurTexte || line.couleurTexte === "000000" && line.couleur === "000000") {
				return "#FFFFFF";
			} else if (line.couleurTexte === line.couleur) {
				return "#000000";
			} else {
				return "#" + line.couleurTexte;
			}
		};

		/**
		 * Retourne la couleur de fond de la ligne
		 * @param line
		 * @returns {string}
		 */
		$scope.getLineBackgroundColor = function (line) {
			return "#" + line.couleur;
		};

		$scope.getDistinctCompanies = function () {
			let distinctList = [];
			let keys = [];

			angular.forEach($scope.data.companies, function (item) {
				let key = item.name;
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					distinctList.push(item);
				}
			});
			return distinctList;
		};

		$scope.sortData = function (column) {
			$scope.reverseSort = ($scope.sortColumn === column) ? !$scope.reverseSort : false;
			$scope.sortColumn = column;

			let sortedList;

			if (column === "position"){
				sortedList = $scope.data.lines.sort(sortbyPosition);
			}
			if (column === "number"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.number,lineB.number));
			}
			if (column === "public_name"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.public_name,lineB.public_name));
			}
			if (column === "commentaire"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.commentaire,lineB.commentaire));
			}
			if (column === "url"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.url,lineB.url));
			}
			if (column === "category"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.category,lineB.category));
			}
			if (column === "codifligne"){
				sortedList = $scope.data.lines.sort((lineA,lineB) => localCompareSort(lineA.codifligne,lineB.codifligne));
			}

			$scope.data.lines = sortedList;
		};



		function localCompareSort(objA, objB) {
			if ($scope.reverseSort){
				if (objA == null){
					return 1;
				}
				return  objA.localeCompare(objB, "en", { numeric: true });
			}
			if (objB == null){
				return 1;
			}
			return  objB.localeCompare(objA, "en", { numeric: true });

		}

		function sortbyPosition(lineA, lineB) {
			if ($scope.reverseSort){
				return lineA.position - lineB.position;
			}
			return lineB.position - lineA.position;
		}

		$scope.getSortClass = function (column) {
			if ($scope.sortColumn === column) {
				return $scope.reverseSort
					? 'fa fa-arrow-up'
					: 'fa fa-arrow-down';
			}
			return '';
		};

		const enabledCssStyle = {
			'color':'black',
			'background-color': '#5cb85c',
		};

		const disabledCssStyle = {
			'color':'black',
			'background-color': '#d9534f',
		};

		const partialCssStyle = {
			'color':'black',
			'background-image': 'linear-gradient(45deg, #d9534f, #d9534f, #5cb85c, #5cb85c)',
			'background-clip': 'text, color: black',
		};

		/**
		 * Renvoie la bonne classe CSS (couleur du bouton) selon si la ligne est TAD
		 */
		$scope.getCssClassFromTad = (tad) => {
			switch (tad) {
				case 'FULL_TAD':
					return enabledCssStyle;
				case 'PARTIAL_TAD':
					return partialCssStyle;
				default:
					return disabledCssStyle;
			}
		};

		/**
		 * Renvoie la bonne classe CSS (couleur du bouton) selon si la ligne est accessible pour les vélos ou PMR
		 */
		$scope.getCssClassFromAccess = (access) => {
			switch (access) {
				case 'TRUE':
					return enabledCssStyle;
				case 'PARTIAL':
					return partialCssStyle;
				case 'FALSE':
					return disabledCssStyle;
				default:
					return {};
			}
		};

		$scope.getCssClassFromBike = (access) => {
			switch (access) {
				case 'FULL_ACCESS':
					return enabledCssStyle;
				case 'PARTIAL_ACCESS':
					return partialCssStyle;
				default:
					return disabledCssStyle;
			}
		};

		$scope.getCssClassFromSchoolBus = (transportSubModeName) => {
			switch (transportSubModeName) {
				case 'SchoolBus':
					return enabledCssStyle;
				default:
					return disabledCssStyle;
			}
		};

		/**
		 * Ouvre la modal d'avertissement de modification TAD'
		 */
		$scope.tadWarningModal = (line) => {
			if (!SecurityService.hasRight('canEditBoardingAlighting')) {
				return;
			}
			$scope.data.currentLine = line;
			$scope.data.currentLineId = line.id;
			$scope.data.tad = line.tad;

			if (line.bookingArrangementInfo != null && line.bookingArrangementInfo.bookingContact != null){
				$scope.data.contactName = line.bookingArrangementInfo.bookingContact.contactPerson;
				$scope.data.phoneNumber = line.bookingArrangementInfo.bookingContact.phone;
				$scope.data.mail = line.bookingArrangementInfo.bookingContact.email;
				$scope.data.url = line.bookingArrangementInfo.bookingContact.url;
			}else{
				$scope.data.contactName = "";
				$scope.data.phoneNumber = "";
				$scope.data.mail = "";
				$scope.data.url = "";
			}

			tadWarningModal = Utils.openModal($uibModal, "tadWarningModal.html", $scope);
		};

		/**
		 * Ouvre la modal d'avertissement de modification wheelchair
		 */
		$scope.wheelchairWarningModal = (line) => {
			if (!SecurityService.hasRight('canEditWheelchair')) {
				return;
			}
			$scope.data.currentLine = line;
			$scope.data.currentLineId = line.id;
			$scope.data.wheelchair = line.wheelchairAccess;
			wheelchairWarningModal = Utils.openModal($uibModal, "wheelchairWarningModal.html", $scope);
		};

		/**
		 * Ouvre la modal d'avertissement de modification bike
		 */
		$scope.bikeWarningModal = (line) => {
			if (!SecurityService.hasRight('canEditBikeBoarding') ) {
				return;
			}
			$scope.data.currentLine = line;
			$scope.data.currentLineId = line.id;
			$scope.data.bike = line.bikeAccess;
			bikeWarningModal = Utils.openModal($uibModal, "bikeWarningModal.html", $scope);
		};

		/**
		 * Ouvre la modal d'avertissement de modification school bus
		 */
		$scope.schoolBusWarningModal = (line) => {
			if (!SecurityService.hasRight('canEditSchoolBus') ) {
				return;
			}
			$scope.data.currentLine = line;
			$scope.data.currentLineId = line.id;
			$scope.data.transportSubModeName = line.transportSubModeName;
			schoolBusWarningModal = Utils.openModal($uibModal, "schoolBusWarningModal.html", $scope);
		};


		let linkToImportCSV;
		$scope.importJourneysCSV = (line) => {
			$scope.data.errorStopTimes = undefined;
			$scope.data.currentLineId = line.id;
			linkToImportCSV = Utils.openModal($uibModal, "import-vehicle-journeys.html", $scope, "lg");
		};

		$scope.closeImportVehicleJourneysModal = function () {
			linkToImportCSV.close();
		};


		$scope.importVehicleJourneysFile = function () {
			if($scope.data.importFile === undefined){
				toastr.error("Sélectionner un fichier", "Erreur lors de l'import");
				$scope.data.importLoading = false;
				return;
			}
			$scope.data.importLoading = true;


			ExploitationService.postVehicleJourneysFile($scope.data.importFile,$scope.data.currentLineId).then((response) => {
				const data = response.data;
				$scope.data.importLoading = false;
				if(data.length > 0){
					$scope.data.errorStopTimes = data;
				}
				else{
					toastr.success("", "Import terminé");
					$scope.closeImportVehicleJourneysModal();
					$scope.data.importFile = undefined;
				}

			}).catch(function (data) {
				toastr.error(data.message, "Erreur lors de l'import");
				$scope.data.importLoading = false;
				$scope.data.importFile = undefined;
				$scope.closeImportVehicleJourneysModal();
			});
		};

		/**
		 * Tronque le texte s'il est trop grand
		 */
		$scope.getTruncatedString = (text) => {
			if(text && text.length > 25) {
				return text.substring(0, 25) + "[...]";
			}
			return text;
		}

		$scope.editLineTad = () => {
			tadWarningModal.dismiss();



			ExploitationService.updateLineBoardingAndAlighting($scope.data.currentLine.id, $scope.data.tad , $scope.data.contactName, $scope.data.phoneNumber, $scope.data.mail, $scope.data.url)
				.then((response) => {
					const line = response.data;
					toastr.success("Modifications enregistrées");

					refreshLines();
					const ref = window.sessionStorage.getItem("referential");
					ExploitationService.updateDexie(ref, line);
				})
				.catch((error) => {
					Utils.makeErrorMessage(error.data, "La modification n'a pas pu être effectuée");
				});
		};



		$scope.editLineWheelchair = () => {
			ExploitationService.updateLineWheelchairAccess($scope.data.currentLine.id, $scope.data.wheelchair)
				.then((response) => {
					const line = response.data;
					toastr.success("Mise à jour de l'accessibilité de la ligne aux usagers en fauteuil réussie.");
					refreshLines();
					const ref = window.sessionStorage.getItem("referential");
					ExploitationService.updateDexie(ref, line);
					wheelchairWarningModal.dismiss();
				})
				.catch(function (error) {
					Utils.makeErrorMessage(error.data, "La modification n'a pas pu être effectuée");
				});
		};

		$scope.editLineBike = () => {
			bikeWarningModal.dismiss();

			let bikeAccess;

			if($scope.data.bike === 'FULL_ACCESS') {
				bikeAccess = "false";
			}
			else {
				bikeAccess = "true";
			}


			ExploitationService.updateLineBikeAccess($scope.data.currentLine.id, bikeAccess)
				.then((response) => {
					const line = response.data;
					if($scope.data.bike === 'FULL_ACCESS') {
						toastr.success("Ligne interdisant les vélos");
					}
					else {
						toastr.success("Ligne autorisant les vélos");
					}
					refreshLines();
					const ref = window.sessionStorage.getItem("referential");
					ExploitationService.updateDexie(ref, line);
				})
				.catch(function (error) {
					Utils.makeErrorMessage(error, "La modification n'a pas pu être effectuée");
				});
		};

		$scope.editSchoolBus = () => {
			schoolBusWarningModal.dismiss();

			let isSchoolBus = $scope.data.transportSubModeName !== 'SchoolBus';

			ExploitationService.updateLineSchoolBus($scope.data.currentLine.id, isSchoolBus)
				.then((response) => {
					const line = response.data;
				if(isSchoolBus) {
					toastr.success("Ligne de bus scolaire");
				}
				else {
					toastr.success("Ligne de bus non-scolaire");
				}
				refreshLines();
				const ref = window.sessionStorage.getItem("referential");
				ExploitationService.updateDexie(ref, line);
			})
			.catch(function (error) {
				Utils.makeErrorMessage(error, "La modification n'a pas pu être effectuée");
			});
		};



	}]);
